import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink, BrowserRouter, useHistory } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import config from '../../config';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { selectDistrict, selectState } from '../Actions/CommonAction';
import { addRecruiter, getCompanyList } from '../Actions/AdminAction';
import { token } from '../Actions/AuthAction';
import Loader from '../Common/Loader';
import ShowError from '../Common/Error';
import { Button } from 'react-bootstrap';

const SupportRozgar = () => {
    return (
        <>
            <div className="row mb-4">
                <div className="col-md-12">
                    <h4 className="table_heading position-relative">SUPPORT</h4>
                </div>
            </div>
            <div className="card formcard">
                <div className="card-body">
                    <div className="row justify-content-center align-content-center" style={{minHeight: "450px"}}>
                        <div class="col-md-4">
                            <div className="text-center">
                                <h1><i class="bi bi-envelope-fill"></i></h1>
                                <h3>Email Us</h3>
                                <p>support@rozgar.com</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div className="text-center">
                                <h1><i class="bi bi-headset"></i></h1>
                                <h3>Contact Us</h3>
                                <p>+91 999 999 9999</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div className="text-center">
                                <h1><i class="bi bi-pin-map-fill"></i></h1>
                                <h3>Address</h3>
                                <p>A51, Sector 16, Noida 201301</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SupportRozgar
